import { registerSkinnableComponent, registerComponent } from '../registry';
import { ProductListSkinnable } from './ProductListSkinnable';
import ProductListComponent from './ProductList.component';
import ProductListEditor from './ProductList.editor';
import { COMPONENT_TYPES } from '../../../constants';

// 스킨 시스템 사용 여부 플래그
const USE_SKIN_SYSTEM = true;

if (USE_SKIN_SYSTEM) {
  // 스킨 시스템을 사용하여 ProductList 컴포넌트 등록
  registerSkinnableComponent(ProductListSkinnable);
} else {
  // 기존 방식으로 ProductList 컴포넌트 등록 (호환성 유지)
  registerComponent({
    type: COMPONENT_TYPES.PRODUCT_LIST,
    component: ProductListComponent,
    editorComponent: ProductListEditor,
    defaultProps: {
      itemsPerRow: 4,
      itemsPerPage: 20
    },
    category: 'ecommerce',
    icon: '🛍️',
    name: '상품 목록'
  });
}

// 컴포넌트 내보내기 - 스킨 시스템 사용 시 New 버전 사용
export { default as ProductListComponent } from './ProductList.component';
export { default as ProductListEditor } from './ProductList.editor'; 